export default __webpack_public_path__ + "static/media/scene.4ffc5518.png";